<div class="controlchat-desktop-page">
  <app-controlchat-v2-widget [embedded]="true"></app-controlchat-v2-widget>
</div>
